import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const LineGraph18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M15.1174 6.851L17.6527 2.36927L16.3472 1.63071L13.9555 5.85858L11.3775 3.80345L11.3683 3.79634C10.7463 3.3161 9.81056 3.53472 9.46586 4.241L7.31346 8.82902L4.75691 6.79106C4.16929 6.29693 3.24673 6.47304 2.88249 7.14897L0.347168 11.6307L1.65274 12.3693L4.04446 8.1414L6.6224 10.1965L6.63161 10.2036C7.25363 10.6839 8.18935 10.4653 8.53405 9.75898L10.6865 5.17096L13.243 7.20891C13.8306 7.70306 14.7532 7.52694 15.1174 6.851Z'
      fill='currentColor'
    />
    <path d='M18 15.25H0V16.75H18V15.25Z' fill='currentColor' />
  </Svg>
);

LineGraph18.displayName = 'LineGraph18';
export default LineGraph18;
